/**
 * Scheduling and safety constants.
 * Rationale for each value: docs/implementation-plan.md ch.2.5, 3.13, 5.
 */

/**
 * Fixed dispatch window. This — not the tick period — bounds how much audio has
 * been handed to Web Audio and therefore can no longer be cancelled.
 */
export const DISPATCH_WINDOW_SEC = 0.2;

/**
 * Dispatch pump interval. "32n" gives 125ms at 60 BPM down to 47ms at 160 BPM,
 * always comfortably shorter than the 200ms window. "64n" would double the
 * callback rate without shrinking the uncancellable window.
 */
export const DISPATCH_TICK_INTERVAL = "32n";
export const BAR_TICK_INTERVAL = "1m";
export const UI_TICK_INTERVAL = "4n";

/** INV-W1: the window must comfortably exceed one tick period. */
export const MIN_WINDOW_TO_TICK_RATIO = 1.5;

/** Number of permanent transport callbacks. Invariant, asserted in tests. */
export const EXPECTED_PERMANENT_EVENTS = 3;

/** Bars kept planned ahead of the current bar. */
export const PLAN_AHEAD_BARS = 2;

/** Master gain ramp for mute/unmute. Short enough to feel immediate, long enough to avoid clicks. */
export const MASTER_RAMP_SEC = 0.02;

/** Extra margin on top of window + lookAhead before un-muting on resume. */
export const RESERVATION_SAFETY_SEC = 0.1;

/** Safety ceiling on master volume. UI cannot exceed this. */
export const MASTER_VOLUME_MAX = 0.8;
/** Deliberately quiet start (about -18 dBFS). */
export const MASTER_VOLUME_DEFAULT = 0.12;

/** Diagnostic click level, well below the master default (about -30 dB relative). */
export const DIAGNOSTIC_CLICK_VELOCITY = 0.25;

export const BPM_MIN = 60;
export const BPM_MAX = 160;
export const BPM_DEFAULT = 96;
/** Max BPM change applied per bar, so already-reserved audio never jumps. */
export const BPM_MAX_STEP_PER_BAR = 2;

/** 4/4 only in Phase 0. */
export const BEATS_PER_BAR = 4;

export const DEFAULT_SEED = "web-improvisation";
